// Mock Data for Transplant Medications Category

const baseProducts = [
    {
        id: "med-transplant-1",
        name: "Tacrolimus 1mg",
        genericName: "Brand: Prograf",
        indication: "Organ Transplant Rejection",
        price: "$120",
        originalPrice: "$1,000",
        savings: "88%",
        description: "An immunosuppressant prescribed to prevent the body from rejecting a transplanted organ such as a kidney, liver, or heart. It works by decreasing the activity of the immune system.",
        dosage: "Typically taken twice daily, 12 hours apart. Must be taken exactly as prescribed.",
        packaging: "Contains 100 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place. Do not expose to extreme heat.",
        sideEffects: "Tremors, headache, diarrhea, high blood pressure, or kidney issues.",
        category: "Immunosuppressants"
    },
    {
        id: "med-transplant-2",
        name: "Mycophenolate 500mg",
        genericName: "Brand: CellCept",
        indication: "Transplant Rejection",
        price: "$84",
        originalPrice: "$1,200",
        savings: "93%",
        description: "Used along with other medications to prevent organ rejection after a kidney, heart, or liver transplant by suppressing the immune system.",
        dosage: "Taken twice daily on an empty stomach. Swallow whole, do not crush or chew.",
        packaging: "Contains 120 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature below 30°C. Protect from light.",
        sideEffects: "Stomach upset, vomiting, diarrhea, or increased risk of infections.",
        category: "Immunosuppressants"
    },
    {
        id: "med-transplant-3",
        name: "Cyclosporine 100mg",
        genericName: "Brand: Neoral / Sandimmune",
        indication: "Transplant Rejection",
        price: "$65",
        originalPrice: "$850",
        savings: "92%",
        description: "A potent immunosuppressive agent used to prevent organ rejection in kidney, liver, and heart transplants. It may also be used for severe rheumatoid arthritis and psoriasis.",
        dosage: "Taken orally twice a day. Maintain consistent timing.",
        packaging: "Contains 50 Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "High blood pressure, kidney problems, increased hair growth, or swollen gums.",
        category: "Immunosuppressants"
    },
    {
        id: "med-transplant-4",
        name: "Sirolimus 2mg",
        genericName: "Brand: Rapamune",
        indication: "Transplant Rejection",
        price: "$154",
        originalPrice: "$2,200",
        savings: "93%",
        description: "An immunosuppressive drug given to prevent rejection of kidney transplants. Often used continuously in regimens without calcineurin inhibitors.",
        dosage: "Taken once daily consistently with or without food.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at 20° to 25°C. Protect from light.",
        sideEffects: "Mouth sores, peripheral edema, high cholesterol, or delayed wound healing.",
        category: "mTOR Inhibitors"
    },
    {
        id: "med-transplant-5",
        name: "Everolimus 0.75mg",
        genericName: "Brand: Zortress",
        indication: "Transplant Rejection",
        price: "$196",
        originalPrice: "$2,800",
        savings: "93%",
        description: "Used to prevent rejection of kidney and liver transplants. It works by reducing the immune system's response to the new organ.",
        dosage: "Taken twice daily, consistently with or without food.",
        packaging: "Contains 60 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from heat and moisture.",
        sideEffects: "Swelling, constipation, nausea, or risk of infections.",
        category: "mTOR Inhibitors"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-transplant-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Transplant Immunology and Rejection Prevention",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic immunosuppressant medication essential for post-transplant care. Sourced from WHO-GMP certified facilities ensuring clinical efficacy and safety.`,
            dosage: "Strictly as prescribed by your transplant team.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your transplant coordinator for specific risks. Regular blood monitoring is mandatory.",
            category: "General Post-Transplant Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const transplantProducts = [...baseProducts, ...generateAlphabetMeds()];

export const transplantHeroData = {
    title: "Transplant Medications",
    subtitle: "Immunosuppressants for organ transplant patients",
    description: "Access life-saving, high-quality immunosuppressants vital for preventing organ rejection. Our global network ensures continuous, reliable access to affordable generics for your post-transplant care.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "90%", label: "Average Savings" }
    ]
};

export const transplantCategories = [
    "All Categories",
    "Immunosuppressants",
    "mTOR Inhibitors",
    "Corticosteroids",
    "Anti-infectives (Prophylaxis)",
    "General Post-Transplant Care"
];

export const transplantTrustBadges = [
    { text: "WHO-GMP Certified", icon: "ShieldCheck" },
    { text: "Reliable Supply", icon: "Clock" },
    { text: "Specialized Pharmacists", icon: "UserCheck" },
    { text: "Bioequivalent Quality", icon: "Award" }
];

export const transplantFAQs = [
    {
        question: "Do I need a prescription to order transplant medications?",
        answer: "Absolutely. All transplant immunosuppressants require a valid prescription from your transplant team or specialist to ensure safe, monitored care."
    },
    {
        question: "Are generic immunosuppressants safe for transplant patients?",
        answer: "Yes. The generics we provide are FDA-approved or WHO-GMP certified as bioequivalent, meaning they have the identical active ingredient, strength, safety, and effectiveness as the brand name drugs."
    },
    {
        question: "How do you ensure I never run out of my critical medication?",
        answer: "We offer dedicated account management for transplant patients, allowing you to set up multi-month supplies (e.g., 3-6 months) with proactive refill reminders and expedited shipping."
    },
    {
        question: "Do you ship international orders securely?",
        answer: "Yes, we utilize vetted, secure international couriers with strict tracking to ensure your life-saving medications reach you safely and on time."
    }
];

export const transplantTestimonials = [
    {
        name: "John D.",
        country: "United States",
        savings: "$15,000 annually",
        condition: "Kidney Transplant",
        medication: "Tacrolimus / Mycophenolate",
        text: "The cost of my anti-rejection meds after Medicare limits was terrifying. MediSeller provided exactly what I needed at a fraction of the cost. My labs have been perfectly stable."
    },
    {
        name: "Maria G.",
        country: "Australia",
        savings: "$12,000 annually",
        condition: "Liver Transplant",
        medication: "Everolimus",
        text: "Switched to generic Zortress through this platform and it's been seamless. The quality is undeniable and the financial relief for me and my family is huge."
    },
    {
        name: "Philip W.",
        country: "United Kingdom",
        savings: "$8,000 annually",
        condition: "Heart Transplant",
        medication: "Cyclosporine",
        text: "Consistent delivery is everything when a missed dose could mean rejection. I trust MediSeller completely for my maintenance meds. They have never let me down."
    }
];

export const transplantSectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Read how transplant recipients maintain their health and financial stability through our services."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information regarding the safe ordering of post-transplant medications."
    },
    midPageCTA: {
        title: "Need to Secure Your Post-Transplant Regimen?",
        description: "Our procurement team can source your exact immunosuppressive combination ensuring uninterrupted care at up to 90% savings.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Medication Plan"
    },
    finalCTA: {
        title: "Protect Your Transplant Affordably",
        description: "Don't compromise your post-transplant health due to high medication costs. Secure your reliable supply today.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
